import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import "./PublicImages.css";
import { FaChevronLeft, FaChevronRight, FaTimes } from "react-icons/fa";

const PublicImages = () => {
    const [images, setImages] = useState([]);
    const { businessId } = useParams();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isFading, setIsFading] = useState(false);
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);

    let touchStartX = 0;
    let touchEndX = 0;

    useEffect(() => {
        if (images.length > 0 && currentIndex >= images.length) {
            setCurrentIndex(0);
        }
    }, [images, currentIndex]);

    const nextImage = () => {
        if (images.length > 0) {

            setIsFading(true);
                setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
                setIsFading(false);

        }
    };

    const prevImage = () => {
        if (images.length > 0) {
            setIsFading(true);

                setCurrentIndex((prevIndex) =>
                    prevIndex === 0 ? images.length - 1 : prevIndex - 1
                );
                setIsFading(false);

        }
    };

    const handleTouchStart = (e) => {
        touchStartX = e.touches[0].clientX;

    };

    const handleTouchMove = (e) => {
        touchEndX = e.touches[0].clientX;

    };

    const handleTouchEnd = () => {
     if (touchEndX) {
        if (touchStartX - touchEndX > 50) {

            nextImage();
        } else if (touchEndX - touchStartX > 50) {

            prevImage();
        }
      }
    };

    useEffect(() => {
        if (businessId) {
            const fetchImages = async () => {
                try {
                    const response = await axios.get(`${process.env.REACT_APP_API_URL}/images/public-images`, {
                        params: { businessId},
                    });
                    setImages(response.data.images);
                } catch (err) {
                    console.error(err.response?.data?.message);
                }
            };
            fetchImages();
        }
    }, [businessId]);

    return (
        <>
            <div
                className="public-gallery-container-image"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd} // Swipe i pro hlavní galerii
            >
                <button className="public-prev-button" onClick={prevImage} disabled={images.length === 0}>
                    <FaChevronLeft className="public-icon" />
                </button>

                <div className="public-image-wrapper" onClick={() => setIsOverlayOpen(true)}>
                    {images.length > 0 ? (
                        <img
                            src={images[currentIndex].fileUrl}
                            alt={`uploaded ${images[currentIndex].filename}`}
                            className={`public-gallery-image ${isFading ? "public-fade" : ""}`}
                        />
                    ) : (
                        <p>Žádné obrázky k zobrazení.</p>
                    )}
                </div>

                <button className="public-next-button" onClick={nextImage} disabled={images.length === 0}>
                    <FaChevronRight className="public-icon" />
                </button>
            </div>

            {/* Overlay pro zvětšený obrázek */}
            {isOverlayOpen && images.length > 0 && (
                <div
                    className="overlay-image active"
                    onClick={() => setIsOverlayOpen(false)}
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd} // Swipe i pro overlay
                >
                    <button className="public-prev-button" onClick={(e) => { e.stopPropagation(); prevImage(); }} disabled={images.length <= 1}>
                        <FaChevronLeft className="public-icon" />
                    </button>

                    <FaTimes className="overlay-close" onClick={() => setIsOverlayOpen(false)} />

                    <img
                        src={images[currentIndex].fileUrl}
                        alt={`uploaded ${images[currentIndex].filename}`}
                    />

                    <button className="public-next-button" onClick={(e) => { e.stopPropagation(); nextImage(); }} disabled={images.length <= 1}>
                        <FaChevronRight className="public-icon" />
                    </button>
                </div>
            )}
        </>
    );
};

export default PublicImages;